import { render, staticRenderFns } from "./RelatedTmpOrder.vue?vue&type=template&id=7bea9d05&scoped=true&lang=pug"
import script from "./RelatedTmpOrder.vue?vue&type=script&lang=js"
export * from "./RelatedTmpOrder.vue?vue&type=script&lang=js"
import style0 from "./RelatedTmpOrder.vue?vue&type=style&index=0&id=7bea9d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea9d05",
  null
  
)

export default component.exports